export * from './common';
export * from './components';
// @ts-ignore
import pj from './package.json';
export const version = pj.version;
//# sourceMappingURL=index.js.map